// extracted by mini-css-extract-plugin
var _1 = "DragFileContainer_filesOnDragModal__ddbd0";
var _2 = "DragFileContainer_help__8aec0";
var _3 = "DragFileContainer_helpText__6c5f3";
var _4 = "DragFileContainer_root__ecff5";
export { _1 as "filesOnDragModal", _2 as "help", _3 as "helpText", _4 as "root" }
